import React from 'react';

import { AlineTooltip, SelectButton } from 'src/components';
import { DeclarativeMenu } from 'src/components/declarative-menu';
import { CapitalizationIcon } from 'src/components/icons/CapitalizationIcon';
import { useEditorLoading } from 'src/layout-engine';
import { makeStyles } from 'tss-react/mui';

import { useCapitalizationMenu } from '../../shared/use-capitalization-menu';

const useStyles = makeStyles()(theme => ({
  button: {
    marginLeft: theme.spacing(0.5),
  },
}));

export function CapitalizationMenu(): JSX.Element {
  const { classes } = useStyles();
  const editorLoading = useEditorLoading();
  const capitalizationMenu = useCapitalizationMenu();

  return (
    <DeclarativeMenu config={capitalizationMenu} disabled={editorLoading}>
      {(renderProps, state) => (
        <AlineTooltip arrow title="Change case">
          <SelectButton
            className={classes.button}
            disabled={state.disabled}
            selected={state.open}
            {...renderProps}
          >
            <CapitalizationIcon />
          </SelectButton>
        </AlineTooltip>
      )}
    </DeclarativeMenu>
  );
}
